export default __webpack_public_path__ + "static/media/thrivecart_logo.081c11da.png";